import Affiliate from "../models/affiliate";
import Album from "../models/album";
import BlogPost from "../models/blogPost";
import Song from "../models/song";

export const getPublicSongImageUrl = (song: Song): string => {
	if (song) {
		if (song.albumId && song.album && song.album.albumImageFileS3Key) {
			return `${process.env.REACT_APP_PUBLIC_S3_ACCESS_POINT}${song.album.albumImageFileS3Key}`;
		} else if (song.songImageFileS3Key) {
			return `${process.env.REACT_APP_PUBLIC_S3_ACCESS_POINT}${song.songImageFileS3Key}`;
		}
	}

	return '';
};

export const getPublicAlbumImageUrl = (album: Album): string => {
	if (album) {
		if (album.albumImageFileS3Key) {
			return `${process.env.REACT_APP_PUBLIC_S3_ACCESS_POINT}${album.albumImageFileS3Key}`;
		}
	}

	return '';
};

export const getPublicAffiliateImageUrl = (affiliate: Affiliate): string => {
	if (affiliate && affiliate.productImageS3Key) {
		return `${process.env.REACT_APP_PUBLIC_S3_ACCESS_POINT}${affiliate.productImageS3Key}`;
	}

	return '';
};

export const getPublicBlogPostHeroImageUrl = (blogPost: BlogPost): string => {
	if (blogPost && blogPost.heroImageS3Key) {
		return `${process.env.REACT_APP_PUBLIC_S3_ACCESS_POINT}${blogPost.heroImageS3Key}`;
	}

	return '';
};

export const getPublicMp3Url = (song: Song): string => {
	if (song) {
		if (song.mp3FileS3Key) {
			return `${process.env.REACT_APP_PUBLIC_S3_ACCESS_POINT}${song.mp3FileS3Key}`;
		}
	}
	
	return '';
}
